import pricingConfiguration from "./pricingConfiguration.component";

const pricingConfigurationModule = angular
  .module("app.components.pricingConfiguration", [])
  .component("pricingConfiguration", pricingConfiguration);

export default pricingConfigurationModule;



// WEBPACK FOOTER //
// ./src/components/pricingConfiguration/pricingConfiguration.module.js